// Page affichée pendant une MAINTENANCE à tout compte qui n'a pas d'accès gardé
// (voir server/src/maintenance/service.js). Elle se referme d'elle-même : l'état
// est relu chaque minute.
//
// Le lien « Accès exploitant » mène à la connexion du back-office : c'est par
// là que le super-administrateur entre pendant la maintenance.
import { useLogout } from '../api/queries';
import type { MaintenanceState } from '../api/types';
import { Button } from '../components/ui';
import { LogoMark, Wordmark } from '../components/Logo';
import { Link } from '../router';
import './maintenance.css';

/** « mercredi 22 octobre vers 9 h 30 » — ou « vers 9 h 30 » si c'est aujourd'hui. */
export function formatUntil(iso: string, now = new Date()): string {
  const d = new Date(iso);
  const time = d.toLocaleTimeString('fr-FR', { hour: 'numeric', minute: '2-digit' }).replace(':', ' h ');
  const sameDay = d.toDateString() === now.toDateString();
  return sameDay ? `vers ${time}` : `le ${d.toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' })} vers ${time}`;
}

export function MaintenancePage({ state, signedIn = false }: { state: MaintenanceState; signedIn?: boolean }) {
  const logout = useLogout();
  return (
    <main className="mt-page">
      <div className="mt-card">
        <div className="mt-brand">
          <LogoMark />
          <Wordmark />
        </div>
        <p className="mt-eyebrow t-mono">Maintenance en cours</p>
        <h1 className="mt-title">Nous revenons très vite.</h1>
        <p className="mt-message">{state.message}</p>
        {state.until ? <p className="mt-until">Retour prévu {formatUntil(state.until)}.</p> : null}
        <p className="mt-note">Cette page se met à jour toute seule : inutile de la recharger.</p>
        {signedIn ? (
          // Connecté sans accès gardé : pouvoir changer de compte (l'exploitant
          // qui s'était connecté avec un autre).
          <Button variant="ghost" className="mt-operator" onClick={() => logout.mutate()} loading={logout.isPending}>
            Se déconnecter
          </Button>
        ) : (
          <Link to="/backoffice" className="mt-operator">
            Accès exploitant
          </Link>
        )}
      </div>
    </main>
  );
}
